import './buttonGroup.scss';
import {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {Button} from "../Button";
import type { ButtonGroupContainerProps, ButtonGroupProps } from "./ButtonGroup.interface";

/**
 * Primary UI component for user interaction
 */
export function ButtonGroup ({
                                                          className,
                                                          id,
                                                          pulledRight,
                                                          buttonSubmit,
                                                          buttonCancel,
                                                          buttonSkip,
                                                          buttonBack,
                                                          keyControlEnabled,
                                                          children,
                                                          formId
                                                        }:ButtonGroupProps) {

  const {t} = useTranslation();

  useEffect(() => {
    if (buttonSubmit) {
      const handleKeyDown = (event: KeyboardEvent) => {
        const element = document.getElementById(buttonSubmit.id);
        if (event.key === "Enter" && !event.repeat && element) {
          const focusedElem = document.activeElement;

          if (focusedElem && focusedElem.closest("form")) {
            // No special handling needed for form childs.
            return;
          }

          element.dispatchEvent(new MouseEvent("click", {bubbles: true}));
        }
      };

      if (keyControlEnabled) {
        document.addEventListener("keydown", handleKeyDown);
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }
    }
  }, [keyControlEnabled, buttonSubmit]);

  return (<ButtonGroupContainer id={id} className={className} pulledRight={pulledRight}>
        {buttonCancel && <Button mode="white" disabled={buttonCancel.disabled} onClick={buttonCancel.onClick} id={buttonCancel.id} label={buttonCancel.label || t('button.cancel')}/>}
        {children}
        {buttonSkip && <Button mode="white" disabled={buttonSkip.disabled} onClick={buttonSkip.onClick} id={buttonSkip.id} label={buttonSkip.label || t('button.skip')}/>}
        {buttonBack && <Button mode="white" disabled={buttonBack.disabled} onClick={buttonBack.onClick} id={buttonBack.id} label={buttonBack.label || t('button.back')}/>}
        {buttonSubmit && <Button type={"submit"} form={formId || buttonSubmit.id + "-form"} mode="yellow" disabled={buttonSubmit.disabled} id={buttonSubmit.id || "submitButtonId"} label={buttonSubmit.label || t('button.next')} loading={buttonSubmit.loading}/>}
  </ButtonGroupContainer>);
}

export function ButtonGroupContainer ({children, id, pulledRight, className}:ButtonGroupContainerProps)  {
  return (
      <div id={id} className={["buttonGroup", pulledRight ? "pulledRight" : "", className || ""].join(" ")}>
        {children}
      </div>
  );
}